import React, { useState } from "react";
import { FaMapMarkerAlt, FaExpand, FaTimes } from "react-icons/fa";

const GeoTaggedImage = ({ src, className = "", coord }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openMap = () => {
    if (coord?.lat && coord?.lng) {
      window.open(
        `https://www.google.com/maps?q=${coord.lat},${coord.lng}`,
        "_blank"
      );
    }
  };

  return (
    <div className={`image-container ${className}`}>
      {/* Image Preview */}
      <div className="image-wrapper" onClick={() => setModalOpen(true)}>
        <img src={src} alt="Preview" className="image-preview" />
        <div className="expand-icon">
          <FaExpand />
        </div>
      </div>

      {/* Coordinates Overlay */}
      {coord?.lat && coord?.lng ? (
        <button className="coord-tag" onClick={openMap}>
          <FaMapMarkerAlt />
          <span>
            {parseFloat(coord.lat).toFixed?.(4)},{" "}
            {parseFloat(coord.lng).toFixed?.(4)}
          </span>
        </button>
      ) : null}

      {/* Full-Screen Modal */}
      {isModalOpen && (
        <div className="image-modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={src} alt="Full View" className="modal-image" />

            {/* Open Map Button */}
            {coord?.lat && coord?.lng ? (
              <button className="map-button" onClick={openMap}>
                <FaMapMarkerAlt />
                Open in Maps
              </button>
            ) : null}

            {/* Close Button */}
            <button
              className="close-button"
              onClick={() => setModalOpen(false)}
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeoTaggedImage;
